import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import NoItemResult from '../../../../../components/results/NoItemResult';

export type BankIntegrationsEmptyProps = { openBankIntegrationDrawer: () => void };

const BankIntegrationsEmpty = ({ openBankIntegrationDrawer }: BankIntegrationsEmptyProps) => {
    const { t } = useTranslation(['sdmModuleDetails']);

    return (
        <NoItemResult
            extra={
                <Button onClick={() => openBankIntegrationDrawer()} type="primary">
                    {t('sdmModuleDetails:actions.createBankIntegrations')}
                </Button>
            }
            subTitle={t('sdmModuleDetails:tabs.bankIntegrations.noData')}
        />
    );
};

export default BankIntegrationsEmpty;
